import { supabase } from "./supabase";

const EMPRESA_ID = "ff438dc8-89fb-4d7c-9ea2-7e09162f242a";
const BUCKET = "perfil-vigilantes";

// Redimensiona imagem para max 400x400px antes do upload
export async function comprimirImagem(file, maxPx = 400) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxPx / Math.max(img.width, img.height));
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      canvas.getContext("2d").drawImage(img, 0, 0, w, h);
      canvas.toBlob(
        (blob) => resolve(new File([blob], "perfil.jpg", { type: "image/jpeg" })),
        "image/jpeg",
        0.85,
      );
    };
    img.src = URL.createObjectURL(file);
  });
}

// Faz upload e salva/atualiza foto_url em liberty_perfil_vigilante
export async function uploadFotoPerfil(file, vigilanteId, vigilanteNome) {
  const compressed = await comprimirImagem(file);
  const path = `${vigilanteId}.jpg`;

  const { error: upErr } = await supabase.storage
    .from(BUCKET)
    .upload(path, compressed, { contentType: "image/jpeg", upsert: true });
  if (upErr) throw new Error(upErr.message);

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  // Cache-bust para forçar re-carregamento após troca de foto
  const fotoUrl = `${data.publicUrl}?v=${Date.now()}`;

  const { error: dbErr } = await supabase
    .from("liberty_perfil_vigilante")
    .upsert(
      {
        vigilante_id:   vigilanteId,
        vigilante_nome: vigilanteNome,
        foto_url:       fotoUrl,
        empresa_id:     EMPRESA_ID,
      },
      { onConflict: "vigilante_id" },
    );
  if (dbErr) throw new Error(dbErr.message);

  return fotoUrl;
}
